import { render, staticRenderFns } from "./index-public.vue?vue&type=template&id=0d6741ae&scoped=true&"
import script from "./index-public.vue?vue&type=script&lang=js&"
export * from "./index-public.vue?vue&type=script&lang=js&"
import style0 from "./index-public.vue?vue&type=style&index=0&id=0d6741ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6741ae",
  null
  
)

export default component.exports